module.exports = (str) => {

    return /^-?\d+$/.test(str);
};
